<template lang="pug">
.stepup
  app-header.header

  //- パンくずリスト
  ul.breadcrumb
    li
      router-link(to="/") {{ $t('Home') }}
    li
      router-link(to="/service_question") {{ $t('Service Questions') }}
    li.active
      router-link(to="/service_question/results") {{ $t('Service Questions Result List') }}
    li.active
      span {{ $t('Service Questions Result Detail') }}
  div(v-if="$route.query.from==='user'")
    .row
      .col-xs-12.mb20
        a(v-on:click="goBack()").btn.btn-default 戻る
  div
    .row
      .col-xs-6
        p(v-if="user") {{ user.attributes['shop-name'] }} {{ user.attributes['user-type-name'] }} 
        h2(v-if="user") {{ user.attributes['user-name'] }} {{ user.attributes['user-firstname'] }}
      .col-xs-6.text-right
        a(v-if="answers.length" v-on:click="goDataDownload()").btn.btn-success 
          i.fa.fa-download
          span 評価シート出力
    .row
      .col-xs-12.mb20
        table(v-if="answers.length")
          tr
            th(rowspan=2) カテゴリー
            th(rowspan=2) シーン
            th(rowspan=2) 評価内容
            template(v-for="(answer_date, index) in answers[0]['answer_start_dates']")
              th.answer_date_current(colspan=2 v-if="index == answers[0]['answer_start_dates'].length - 1") {{answer_date}}
              th.answer_date(colspan=2 v-else) {{answer_date}}
          tr
            template(v-for="answer_date in answers[0]['answer_start_dates']")
              th.point 他己評価
              th.own_point 自己評価
          tr
            th(colspan=3) 総合評価
            template(v-for="(_, index) in answers[0]['answer_start_dates']")
              td.point {{ answers[0]['points'][index] > 0 ? answers[0]['points'][index] : '-' }}
              td.own_point {{ answers[0]['own_points'][index] > 0 ? answers[0]['own_points'][index] : '-'}}
          template(v-for="(answer, index) in answers")
            template(v-if="index > 0")
              tr
                th(v-if="!answers[index - 1]['category_id'] || answers[index - 1]['category_id'] !== answer['category_id']" :rowspan="answer['rowspan']") {{ answer['category_name'] }}
                th {{ answer['scene'] }}
                th {{ answer['content'] }}
                template(v-for="(point, answerIndex) in answer['points']")
                  template(v-if="(!answers[index - 1]['category_id'] || answers[index - 1]['category_id'] !== answer['category_id']) && answer['is_different'][answerIndex]")
                    td.point(:rowspan="answer['rowspan']") {{ point || '-' }}
                    td.own_point(:rowspan="answer['rowspan']") {{ answer['own_points'][answerIndex] || '-' }}
                  template(v-else-if="answer['is_different'][answerIndex]")
                  template(v-else)
                    td.point {{ point || '-' }}
                    td.own_point {{ answer['own_points'][answerIndex] || '-' }}
          tr
            th.text-right(colspan="3") 評価者
            template(v-for="(answerUsers, index) in answers[0]['answer_users']")
              td(colspan="2")
                p(v-for="answerUser in answerUsers") {{answerUser}}
              
    .row
      .col-xs-12.mb20
        label 前回情報共有コメント
        textarea.form-control(rows=5, readonly='readonly', v-model="lastComment")
    .row
      .col-xs-12.mb20
        label 情報共有コメント
        textarea.form-control(rows=5, v-model="comment")
    .row.mb20(v-if="$route.query.from==='user'")
      .col-sm-4
      .col-sm-4.text-center
        a(v-on:click="saveComment()").btn.btn-success.btn-lg 保存
      .col-sm-4.text-right
        a(v-on:click="goBack()").btn.btn-default.btn-lg 戻る
    .row.mb20(v-else)
      .col-xs-12.text-center
        a(v-on:click="saveComment()").btn.btn-success.btn-lg 保存
</template>
<script>
import AppHeader from './AppHeader'

export default {
  name: 'service-question-result-detail',
  components: {
    AppHeader
  },
  data () {
    return {
      answers: [],
      lastComment: '',
      comment: ''
    }
  },
  computed: {
    user () {
      return this.$store.getters.userDetail
    },
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isShopMaster () {
      return this.$store.getters.shopMaster
    }
  },
  created () {
    this.searchUser()
    this.search(false)
  },
  methods: {
    searchUser () {
      this.$store.dispatch('USER_DETAIL', { id: this.$route.params.targetUserId })
    },
    goBack () {
      this.$router.push({ path: `/users/${this.$route.params.targetUserId}` })
    },
    async search () {
      let data = {
        service_question_id: this.$route.params.serviceQuestionId,
        target_user_id: this.$route.params.targetUserId,
        answer_start_date: this.$route.params.answerStartDate
      }
      let res = await this.$store.dispatch('GET_SERVICE_RESULT_DETAIL', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.answers = res
      let resComment = await this.$store.dispatch('GET_SERVICE_RESULT_COMMENT', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.comment = resComment.comment
      this.lastComment = resComment.last_comment
    },
    saveComment () {
      let data = {
        service_question_id: this.$route.params.serviceQuestionId,
        target_user_id: this.$route.params.targetUserId,
        answer_start_date: this.$route.params.answerStartDate,
        comment: this.comment
      }
      this.$store.dispatch('UPDATE_SERVICE_RESULT_COMMENT', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
    },
    async goDataDownload () {
      let data = {
        service_question_id: this.$route.params.serviceQuestionId,
        target_user_id: this.$route.params.targetUserId,
        answer_start_date: this.$route.params.answerStartDate
      }
      let res = await this.$store.dispatch('DOWNLOAD_SERVICE_RESULT_DETAIL', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      window.open(res.url)
      data = {
        file_name: res.file_name
      }
      window.setTimeout(async function () {
        await this.$store.dispatch('DELETE_SERVICE_RESULT_DETAIL', { data: data })
      }, 3000)
    }
  }
}
</script>
<style scoped>
h2 {
  margin: 8px 0px 16px;
}
table {
  width: 100%;
}
th {
  border: 1px solid #ddd;
  padding: 8px;
}
td {
  border: 1px solid #ddd;
  padding: 8px;
}
.answer_date {
  text-align: center;
}
.answer_date_current {
  color: #fff;
  background-color: #f0ad4e;
  text-align: center;
}
td.point {
  color: #DB5A5A;
  font-size: 16px;
  font-weight: bold;
}
.own_point {
  background-color: #eee;
}
td.own_point {
  color: #C97C00;
  font-size: 14px;
}
.mb20 {
  margin-bottom: 24px;
}
</style>


// WEBPACK FOOTER //
// ServiceQuestionResultDetail.vue?0ab0444e